<template>
    <div class="row">
      <div class="col-12">
        <div v-if="fetchingPayments">Παρακαλώ περιμένετε...</div>
        <div v-else>
          <div v-if="payments.length === 0">Δε βρέθηκαν πληρωμές</div>
          <div v-else class="table-responsive">
            <div class="mb-4">
              <div class="float-left"><button class="btn btn-sm" :disabled="pagination.currentPage===1" @click="changePage(pagination.currentPage-1)"><i class="ti-arrow-left"></i>&nbsp;Νεοτερες</button></div>
              <div class="float-right"><button class="btn btn-sm" :disabled="pagination.currentPage===pagination.totalPages" @click="changePage(pagination.currentPage+1)">Παλαιοτερες&nbsp;<i class="ti-arrow-right"></i></button></div>
              <div class="clear"></div>
            </div>
            <table class="table">
              <thead>
                <tr>
                  <th>Ημερομηνία</th>
                  <th class="text-right">Ποσό</th>
                  <th class="text-center">Τρόπος Πληρωμής</th>
                  <th class="text-center">Κατάσταση</th>
                  <th style="max-width:200px;">Περιγραφή</th>
                  <th class="text-right">Παραστατικό</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(payment, index) in payments" :key="index">
                  <td>{{ (new Date(payment.createdAt)).toLocaleString('el-GR') }}</td>
                  <td class="text-right">{{ payment.amount }}&euro;</td>
                  <td class="text-center">{{ paymentMethods[payment.paymentMethod] }}</td>
                  <td class="text-center">
                    {{ statuses[payment.status] }}
                    <div v-if="payment.status==='error'">
                        {{ payment.errorMessage }}
                    </div>
                  </td>
                  <td>{{ payment.comment }}</td>
                  <td>
                    <div v-if="payment.invoiceDto.id" class="text-right">
                      <div>{{ statuses[payment.invoiceDto.status] }}</div>
                      <div v-if="payment.invoiceDto.status==='published'">
                        {{ (new Date(payment.invoiceDto.issuedAt)).toLocaleDateString('el-GR') }}
                        <div v-if="fetchingInvoiceForPayment === payment.referenceId">Γίνεται λήψη...</div>
                        <div v-else><a href="javascript:void(0);" @click="getInvoiceUrl(payment.referenceId);"><span class="ti-download"></span>&nbsp;Λήψη</a></div>
                      </div>
                      <div v-if="payment.invoiceDto.status==='error'">
                        {{ payment.invoiceDto.errorMessage }}
                      </div>
                    </div>
                    <div v-else class="text-right">-</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Api from "../api";
export default {
  components: {
    
  },
  data() {
    return {
      payments: [],
      pagination: {
        totalRows: 0,
        totalPages: 0,
        currentPage: 1,
        perPage: 20
      },
      fetchingPayments: true,
      fetchingInvoiceForPayment: null,
      statuses: {
        error: "Σφάλμα",
        success: "Επιτυχία",
        pending: "Εκρεμμεί",
        published: "Εκδόθηκε"
      },
      paymentMethods: {
        credit_card: "Κάρτα",
        web_banking: "Web Banking"
      }
    };
  },
  mounted() {
    this.getPayments();
  },
  methods: {
    getPayments () {
      this.fetchingPayments = true;
      Api.send("GET", "/payments?page=" + this.pagination.currentPage + "&per_page=" + this.pagination.perPage, {})
        .then((response) => {
          this.payments = response.paymentDtos;
          this.pagination.currentPage = response.paginationDto.currentPage;
          this.pagination.perPage = response.paginationDto.perPage;
          this.pagination.totalRows = response.paginationDto.totalRows;
          this.pagination.totalPages = response.paginationDto.totalPages;
        })
        .catch((err) => {
          
        })
        .finally(() => {
          this.fetchingPayments = false;
        });
    },
    changePage(page) {
      if (page < 1 || page > this.pagination.totalPages) {
        return false;
      }
      this.pagination.currentPage = page;
      this.getPayments();
    },
    getInvoiceUrl(paymentReference) {
      let self = this;
      self.fetchingInvoiceForPayment = paymentReference;
      Api.send("GET", "/payments/" + paymentReference + "/invoice_url", {})
        .then((response) => {
          window.open(response.data.url, '_blank');
        })
        .catch((err) => {
          self.$root.notifyy('danger', err.msg);
        })
        .finally(() => {
          self.fetchingInvoiceForPayment = null;
        });
    }
  },
};
</script>
<style scoped>
.clear {
  clear: both;
}
</style>
